import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@shared/api/client";

const BASE = "/settings/billing";

export interface BillingConfig {
  iva_tipos: number[];
  iva_defecto: number;
  vencimiento_dias: number;
}

export const billingConfigKey = ["settings", "billing-config"] as const;

export function useBillingConfig() {
  return useQuery({
    queryKey: billingConfigKey,
    queryFn: async () => {
      const { data } = await api.get<{ data: BillingConfig }>(BASE);
      return data.data;
    },
  });
}

export function useUpdateBillingConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (payload: Partial<BillingConfig>) => {
      const { data } = await api.patch(BASE, payload);
      return data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: billingConfigKey }),
  });
}
